import React, { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FlowToggleContext = createContext();

export const useFlowToggle = () => {
  const context = useContext(FlowToggleContext);
  if (!context) {
    throw new Error('useFlowToggle must be used within a FlowToggleProvider');
  }
  return context;
};

export const FlowToggleProvider = ({ children }) => {
  const location = useLocation();

  const isTechnicalPath = (path) => {
    if (!path) return false;
    return (
      path.startsWith('/technical') ||
      path.startsWith('/projects/fir-requests') ||
      path.includes('/fir-mappings') ||
      path.includes('/manage-fir-mappings')
    );
  };

  // Initialize state based on the current URL
  const [isTechnicalFlow, setIsTechnicalFlow] = useState(() => {
    if (typeof window !== 'undefined') {
      return isTechnicalPath(window.location.pathname);
    }
    return false;
  });

  // Sync state with URL changes
  useEffect(() => {
    const path = location.pathname;
    if (isTechnicalPath(path)) {
      setIsTechnicalFlow(true);
    } else {
      setIsTechnicalFlow(false);
    }
  }, [location.pathname]);


  const toggleFlow = () => {
    setIsTechnicalFlow(prev => !prev);
  };

  const value = {
    isTechnicalFlow,
    toggleFlow,
    setIsTechnicalFlow,
  };

  return (
    <FlowToggleContext.Provider value={value}>
      {children}
    </FlowToggleContext.Provider>
  );
};
